import React, { useState, useEffect } from 'react';
import { Breadcrumbs, Link, Typography, Grid, TextField, Checkbox, useMediaQuery, useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import KAppBar from '../../../components/KAppBar';
import KTable from '../../../components/KTable';
import transportadoraRepositorio from '../../../repositorios/transportadora/transportadoraRepositorio';
import KLoader from '../../../components/KLoader';
import KSnackbar from '../../../components/KSnackbar';
import KDialogCadastro from '../../../components/KDialogCadastro';
import KSearchField from '../../../components/KSearchfield/index';
import cidadeRepositorio from '../../../repositorios/cidade/cidadeRepositorio';
import estadoRepositorio from '../../../repositorios/estado/estadoRepositorio';
import KMaskTextField from '../../../components/KMaskTextField';
import { ISnack } from '../../../Types';


const ListaTransportadora = () => {
    const history = useHistory();
    const theme = useTheme();
    const responsive = useMediaQuery(theme.breakpoints.down('sm'));
    const [transportadora, setTransportadora] = useState<any>({})
    const [transportadoras, setTransportadoras] = useState<Array<any>>([]);
    const [cidades, setCidades] = useState<Array<object>>([]);
    const [cidade, setCidade] = useState<any>(null);
    const [estado, setEstado] = useState<any>(null);
    const [estados, setEstados] = useState<Array<object>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [snackbar, setSnackbar] = useState<ISnack>({
        visible: false,
        variant: 'success',
        message: 'Dados Salvos'
    });

    const handleLinkClick = (path: string) => {
        history.push(path);
    }

    useEffect(() => {
        setEstado(transportadora.idtransportadora ? {
            value: transportadora.idestado,
            label: transportadora.estado.nome
        } : null)
        setCidade(transportadora.idtransportadora ? {
            value: transportadora.idcidade,
            label: transportadora.cidade.nome
        } : null)
    }, [transportadora.idtransportadora])

    const handleChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTransportadora({
            ...transportadora,
            [event.target.name]: event.target.value
        })
    }
    const handleChangedCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTransportadora({
            ...transportadora,
            [event.target.name]: event.target.checked
        })
    }

    const handleChangeAuto = (campo: any, valor: any) => {
        setTransportadora({
            ...transportadora,
            [campo]: valor
        })
    }

    const handleValidacoes = () => {
        if (!transportadora.nome) {
            return {
                type: 'error',
                message: 'Nome não pode ser vazio'
            }
        }
        if (!transportadora.cnpjcpf) {
            return {
                type: 'error',
                message: 'Cnpj não pode ser vazio'
            }
        }
        if (!cidade) {
            return {
                type: 'error',
                message: 'Cidade não pode ser vazio'
            }
        }
        if (!estado) {
            return {
                type: 'error',
                message: 'Estado não pode ser vazio'
            }
        }
        if (!transportadora.ie) {
            return {
                type: 'error',
                message: 'Inscrição Estadual não pode ser vazio'
            }
        }
        return {
            type: 'success',
            message: ''
        }
    }

    //TODO fazer campo de máscara e responsividade na tabela e floatbutton

    const loadTransportadoras = async () => {
        try {
            setIsLoading(true);
            const listaTransportadoras = await transportadoraRepositorio.getAll();
            const cidades = await cidadeRepositorio.getSearchField();
            const estados = await estadoRepositorio.getSearchField();

            setCidades(cidades);
            setEstados(estados);
            setTransportadoras(listaTransportadoras.data);
        } catch (e) {
            setSnackbar({
                visible: true,
                variant: 'error',
                message: 'Não foi possivel Carregar'
            })
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            await loadTransportadoras();
        })()
    }, [])

    return (
        <KAppBar>
            <div>
                <KLoader isLoading={isLoading} />
                <KSnackbar
                    snackbar={snackbar}
                    setSnackbar={setSnackbar}
                />
                <Breadcrumbs separator=">">
                    <Link style={{ cursor: 'pointer' }} onClick={() => handleLinkClick('/dashboard')}>Dashboard</Link>
                    <Link style={{ cursor: 'pointer' }} onClick={() => handleLinkClick('/transportadoras')}>Transportadoras</Link>
                </Breadcrumbs>
                <Typography variant="h5">Transportadoras</Typography>

                <KTable
                    editable
                    title="Transportadoras"
                    searchBar
                    searchBarItems={["idtransportadora", "nome"]}
                    cadastro
                    maxWidth="md"
                    item={transportadora}
                    setItem={setTransportadora}
                    iditem="idtransportadora"
                    route="transportadora"
                    loadItems={loadTransportadoras}
                    itemsHeader={["Id", "Nome"]}
                    itemsName={["idtransportadora", "nome"]}
                    items={transportadoras}
                    setItems={setTransportadoras}
                    validator={handleValidacoes}
                >

                    <Grid container spacing={2} item xs={12}>
                        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                            <Checkbox onChange={handleChangedCheckbox} name="ativo" checked={transportadora.ativo} color="primary" />
                            <Typography>Ativo</Typography>
                        </Grid>
                        <Grid item xs={!responsive ? 6 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Nome"
                                name="nome"
                                value={transportadora.nome || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 3 : 12}>
                            <KMaskTextField
                                mask="99.999.999/9999-99"
                                label="Cnpj"
                                name="cnpjcpf"
                                value={transportadora.cnpjcpf || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 3 : 12}>
                            <KMaskTextField
                                mask="999.999.999"
                                label="IE"
                                name="ie"
                                value={transportadora.ie || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 6 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Endereço"
                                name="endereco"
                                value={transportadora.endereco || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 6 : 12}>
                            <KSearchField
                                {...{ itens: cidades, value: cidade, setValue: setCidade, label: 'Cidade' }}
                                name="idcidade"
                                onChange={handleChangeAuto}
                            />

                        </Grid>
                        <Grid item xs={!responsive ? 4 : 12}>
                            <KSearchField
                                {...{ itens: estados, value: estado, setValue: setEstado, label: 'Estado' }}
                                name="idestado"
                                onChange={handleChangeAuto}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 4 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Bairro"
                                name="bairro"
                                value={transportadora.bairro || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 2 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Complemento"
                                name="complemento"
                                value={transportadora.complemento || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 2 : 12}>
                            <KMaskTextField
                                mask="99999-999"
                                label="Cep"
                                name="cep"
                                value={transportadora.cep || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 3 : 12}>
                            <KMaskTextField
                                mask="(99)9999-9999"
                                label="Fone"
                                name="fone"
                                value={transportadora.fone || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 2 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Ramal"
                                name="ramal"
                                value={transportadora.ramal || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 3 : 12}>
                            <KMaskTextField
                                mask="(99)99999-9999"
                                label="Celular"
                                name="fax"
                                value={transportadora.fax || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={!responsive ? 4 : 12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Contato"
                                name="contato"
                                value={transportadora.contato || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="dense"
                                label="Email"
                                name="email"
                                value={transportadora.email || ''}
                                onChange={handleChanged}
                            />
                        </Grid>
                    </Grid>
                </KTable>
            </div>
        </KAppBar>
    )
}

export default ListaTransportadora;